import { render, staticRenderFns } from "./TemplateDetailsPageContent.vue?vue&type=template&id=ee18d9a2&scoped=true"
import script from "./TemplateDetailsPageContent.vue?vue&type=script&lang=js"
export * from "./TemplateDetailsPageContent.vue?vue&type=script&lang=js"
import style0 from "./TemplateDetailsPageContent.vue?vue&type=style&index=0&id=ee18d9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee18d9a2",
  null
  
)

export default component.exports